// extracted by mini-css-extract-plugin
module.exports = {"ModalContainer":"style_ModalContainer__8EiMk","CloseBtn":"style_CloseBtn__wA7Ac","Body":"style_Body__2q-jN","ModalTitle":"style_ModalTitle__VFNqH"};